<template>
    <span v-if="show"
          class="error-handler">
        <hh-error-display v-if="errorMessage"
                          :error="errorMessage" />
        <hh-error-display v-else-if="hasSlot">
            <slot />
        </hh-error-display>
        <template v-if="showReportingLink">
            <span v-if="reported" class="error-handler__report-result">{{ reportedMessage }}</span>
            <a v-else class="error-handler__report-link" href="#" @click="onErrorReportClick">Report this problem to us</a>
        </template>
    </span>
</template>

<script>

import _ from 'lodash'
import Vuex from 'vuex'

import Config from '@/app.config'
import ServiceFactory from '@/services/service-factory'

import { MUTATIONS } from '@/store/mutations'
import Store from '@/store'

import AppError from '@/models/app-error'

export default {

    props: {
        allowReporting: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            reporting: false,
            reported: false,
            reportedMessage: 'Thank you for reporting this to us.',
            storedErrors: [],
        }
    },

    watch: {
        appErrors(newArray) {
            if (newArray.length) {
                newArray.forEach(err => {
                    const matched = this.storedErrors.find(item => item.message == err.message)
                    if (!matched)
                        this.storedErrors.push(_.clone(err))
                    else
                    if (!matched.allowReporting) matched.allowReporting = err.allowReporting

                })
            } else {
                this.storedErrors = []
            }
        },
    },

    computed: {
        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Array<string>}
             */
            appErrors: stateStore => stateStore.appErrors && stateStore.appErrors.length ? stateStore.appErrors : [],
        }),

        appErrorsMessage() {
            const msgArr = []
            this.storedErrors.forEach(err => {
                if (!msgArr.includes(err.message)) msgArr.push(err.message)
            })
            return msgArr.join(', ')
        },

        dataSource() {
            return this.error ? 'prop' : !this.hasSlot ? 'store' : 'slot'
        },

        errorMessage() {
            return this.error ? this.error : !this.hasSlot ? this.appErrorsMessage : null
        },

        errorsToReport() {
            return this.error
                ? [ new AppError(this.errorMessage, true) ]
                : this.storedErrors
        },

        hasSlot() {
            return this.$slots.default ? true : false
        },

        show() {
            return this.errorMessage || this.hasSlot
        },

        showReportingLink() {
            return this.allowReporting || this.dataSource == 'store' && this.storedErrors.filter(e => e.allowReporting).length > 0
        },
    },

    created() {
        this.storedErrors = this.appErrors
    },

    mounted() {
        Store.commit(MUTATIONS.clearAllErrors)
        this.storedErrors = this.appErrors

        if (Config.test.showError && process.env.NODE_ENV !== 'production' && this.appErrors.length == 0)
            this.$store.commit(MUTATIONS.logAppError, new AppError(`This is a test error. To remove, disable test.showError in app config.`, true))
    },

    methods: {

        async onErrorReportClick() {
            if (!this.reporting) {
                this.reporting = true
                try {
                    const service = ServiceFactory.contact()

                    if (this.errorsToReport.length == 0)
                        this.errorsToReport.push(new AppError('An error has occurred', false))

                    for (let i = 0; i < this.errorsToReport.length; i++) {
                        const err = this.errorsToReport[i]

                        // eslint-disable-next-line no-await-in-loop
                        const operationState = await service.reportErrorAsync(this.$scheme.id, err)
                        if (!operationState.succeeded) operationState.throw()
                    }

                    this.reporting = false
                    this.reported = true
                } catch (err) {
                    this.reporting = false
                    this.reported = true
                    this.reportedMessage = 'Unable to report this issue at this time - please try later.'
                }
            }
        },
    },
}

</script>

<style lang="scss">

</style>
